import React, { useState, useRef } from "react";
import { useMachine } from "../../contexts/MachineContext";

export default function MachinePlayer({ show }) {
	const stringInputRef = useRef();
	const [tested, setTested] = useState(false);
	const [success, setSuccess] = useState(false);

	const { recognizeString, initialStateID } = useMachine();

	function RunMachine() {
		setTested(true);
		const accepted = recognizeString(stringInputRef.current.value, initialStateID);

        setSuccess(accepted);
	}

	return (
		<div className={`editor-panel machine-player ${show ? "open" : ""}`}>
			<p className="panel-title">Ejecutar autómata</p>
			<div className="setting">
				<p className="setting-title">Reconocer Cadena</p>
				<input
					type="text"
					className="setting-input"
					ref={stringInputRef}
					onChange={() => setTested(false)}
                    placeholder="ε (Cadena vacía)"
				/>
				<div className="setting-actions">
					<div
						className={`result ${
							tested ? (success ? "success" : "fail") : "waiting"
						}`}
					>
						<p className="text">
							{tested
								? success
									? "Aceptada"
									: "No aceptada"
								: "-"}
						</p>
					</div>
					<button className="button" onClick={RunMachine}>
						Reconocer
					</button>
				</div>
			</div>
		</div>
	);
}
